import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'
import { GroupPricingsListWrapper } from './groups-pricings-list/GroupPricingsList'

const grouppricingsBreadcrumbs: Array<PageLink> = [
  {
    title: 'GroupPricing Management',
    path: '/admin/pages/grouppricings',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/grouppricings/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const GroupPricingsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='grouppricings'
          index
          element={
            <>
              <PageTitle breadcrumbs={grouppricingsBreadcrumbs}>GroupPricings list</PageTitle>
              <GroupPricingsListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/grouppricings/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/grouppricings' />} />
    </Routes>
  )
}

export default GroupPricingsPage
